import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';


export interface PieChartItem {
  name: string;
  value: number;
  percentage?: string;
}

@Component({
  selector: 'pie-chart',
  templateUrl: './pie.component.html',
  styleUrls: ['./pie.component.scss'],
  animations: fuseAnimations
})
export class PieChartComponent implements OnChanges {
  @Input() results: PieChartItem[] = [];
  @Input() title: string;
  @Input() isLoading = true;
  @Input() view = [200, 200];
  @Input() legendPosition = 'below';
  @Input() schemePieColor = {
    domain: ['#0054ff', '#ff3365', '#f9bb42', '#00194a', '#b0bacf', '#12b886', '#58595b']
  };
  labelColorDomain: any[] = [];
  totalValue: number;

  constructor(private fuseTranslationLoaderService: FuseTranslationLoaderService) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  ngOnChanges(changes: any): void {
    if (Array.isArray(this.results)) {
      const diff = Math.ceil(this.results.length / this.schemePieColor.domain.length) - 1;

      this.labelColorDomain = this.schemePieColor.domain;
      for (let index = 0; index < diff; index++) {
        this.labelColorDomain = this.labelColorDomain.concat(this.schemePieColor.domain);
      }
    }

    if (changes.results && changes.results.currentValue){
      this.totalValue = this.results.reduce((accumulator, current) => {
        return accumulator + current.value;
      }, 0);

      this.results.forEach((result) => {
        result['percentage'] = (Math.round((result.value / this.totalValue) * 100)).toFixed(0);
      });
    }
  }

  formatTooltip(data): string {
    return `
      <div class="pt-4">
        ${data.data.name}<br/>
        <span class="font-size-16">${data.data.value}</span>
      </div>
    `;
  }

}
